import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMapPin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fill="#B2B2B2"
      fillRule="evenodd"
      d="M2 6v.293c0 1.429.486 2.815 1.379 3.93L8 16l4.621-5.776A6.3 6.3 0 0 0 14 6.293V6A6 6 0 0 0 2 6m6 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapPin;
